<template>
    <v-app-bar app  color="#3374ff" id="nav" >
      <a href="https://oeaq.qc.ca/" target="_blank" class="white--text">Ordre des Évaluateurs Agréés du Québec</a>
    </v-app-bar>
</template>

<script>
export default {

}
</script>

<style lang="scss">
#nav{
  a {
    text-decoration: none;
    font-size: 1.5em;
    letter-spacing: 1px;
    text-align: right;
    @media screen and(max-width: 800px){
      font-size: 1em;
    }
  }
}
</style>